import { useQuery } from '@tanstack/react-query';
import Globals from '../Globals.json';
import api from '../Services/api';

export const useProductsQuery = (
  storeId: number,
  page: number,
  name?: string
) => {
  return useQuery({
    queryKey: ['products', storeId, page, name],
    queryFn: async () => {
      let uri = `?filter[product_type_id]=0&filter[is_active]=1&page=${page}&per_page=15&store_id=${storeId}`;

      if (name && name.length > 2) {
        uri += `&filter[product_name]=${name}`;
      }

      const { data } = await api.get(Globals.api.products + '/minified' + uri + '&id_number=43');
      return data;
    },
    refetchInterval: false, // formulário/dado de referência: sem atualização automática
    enabled: !!storeId,
  });
};
